import {
  GET_MESSAGING_USERS_REQUEST,
  GET_MESSAGING_USERS_SUCCESS,
  GET_MESSAGING_USERS_FAIL,
  GET_MESSAGING_USERS_RESET,
  SEND_DIRECT_MESSAGE_REQUEST,
  SEND_DIRECT_MESSAGE_SUCCESS,
  SEND_DIRECT_MESSAGE_FAIL,
  SEND_DIRECT_MESSAGE_RESET,
  GET_MESSAGE_TEMPLATES_REQUEST,
  GET_MESSAGE_TEMPLATES_SUCCESS,
  GET_MESSAGE_TEMPLATES_FAIL,
  GET_MESSAGE_TEMPLATES_RESET,
  GET_USER_MESSAGE_HISTORY_REQUEST,
  GET_USER_MESSAGE_HISTORY_SUCCESS,
  GET_USER_MESSAGE_HISTORY_FAIL,
  GET_USER_MESSAGE_HISTORY_RESET,
  CLAIM_VOUCHER_REQUEST,
  CLAIM_VOUCHER_SUCCESS,
  CLAIM_VOUCHER_FAIL,
  CLAIM_VOUCHER_RESET,
  GET_VOUCHER_STATUS_REQUEST,
  GET_VOUCHER_STATUS_SUCCESS,
  GET_VOUCHER_STATUS_FAIL,
  GET_VOUCHER_STATUS_RESET,
  GET_MY_VOUCHERS_REQUEST,
  GET_MY_VOUCHERS_SUCCESS,
  GET_MY_VOUCHERS_FAIL,
  GET_MY_VOUCHERS_RESET,
} from '../constants/messagingConstants'

// ===========================
// Simplified Messaging Reducers
// ===========================

export const getMessagingUsersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MESSAGING_USERS_REQUEST:
      return { loadingGetMessagingUsers: true }
    case GET_MESSAGING_USERS_SUCCESS:
      return { loadingGetMessagingUsers: false, getMessagingUsersData: action.payload }
    case GET_MESSAGING_USERS_FAIL:
      return { loadingGetMessagingUsers: false, errorGetMessagingUsers: action.payload }
    case GET_MESSAGING_USERS_RESET:
      return {}
    default:
      return state
  }
}

export const sendDirectMessageReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_DIRECT_MESSAGE_REQUEST:
      return { loadingSendDirectMessage: true }
    case SEND_DIRECT_MESSAGE_SUCCESS:
      return { loadingSendDirectMessage: false, successSendDirectMessage: true, sendDirectMessageData: action.payload }
    case SEND_DIRECT_MESSAGE_FAIL:
      return { loadingSendDirectMessage: false, errorSendDirectMessage: action.payload }
    case SEND_DIRECT_MESSAGE_RESET:
      return {}
    default:
      return state
  }
}

export const getMessageTemplatesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MESSAGE_TEMPLATES_REQUEST:
      return { loadingGetMessageTemplates: true }
    case GET_MESSAGE_TEMPLATES_SUCCESS:
      return { loadingGetMessageTemplates: false, getMessageTemplatesData: action.payload }
    case GET_MESSAGE_TEMPLATES_FAIL:
      return { loadingGetMessageTemplates: false, errorGetMessageTemplates: action.payload }
    case GET_MESSAGE_TEMPLATES_RESET:
      return {}
    default:
      return state
  }
}

export const getUserMessageHistoryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_MESSAGE_HISTORY_REQUEST:
      return { loadingGetUserMessageHistory: true }
    case GET_USER_MESSAGE_HISTORY_SUCCESS:
      return { loadingGetUserMessageHistory: false, getUserMessageHistoryData: action.payload }
    case GET_USER_MESSAGE_HISTORY_FAIL:
      return { loadingGetUserMessageHistory: false, errorGetUserMessageHistory: action.payload }
    case GET_USER_MESSAGE_HISTORY_RESET:
      return {}
    default:
      return state
  }
}


// ===========================
// Voucher Reducers
// ===========================

export const claimVoucherReducer = (state = {}, action) => {
  switch (action.type) {
    case CLAIM_VOUCHER_REQUEST:
      return { loadingClaimVoucher: true }
    case CLAIM_VOUCHER_SUCCESS:
      return { loadingClaimVoucher: false, claimVoucherData: action.payload }
    case CLAIM_VOUCHER_FAIL:
      return { loadingClaimVoucher: false, errorClaimVoucher: action.payload }
    case CLAIM_VOUCHER_RESET:
      return {}
    default:
      return state
  }
}

export const getVoucherStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_VOUCHER_STATUS_REQUEST:
      return { loadingGetVoucherStatus: true }
    case GET_VOUCHER_STATUS_SUCCESS:
      return { loadingGetVoucherStatus: false, getVoucherStatusData: action.payload }
    case GET_VOUCHER_STATUS_FAIL:
      return { loadingGetVoucherStatus: false, errorGetVoucherStatus: action.payload }
    case GET_VOUCHER_STATUS_RESET:
      return {}
    default:
      return state
  }
}

export const getMyVouchersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MY_VOUCHERS_REQUEST:
      return { loadingGetMyVouchers: true }
    case GET_MY_VOUCHERS_SUCCESS:
      return { loadingGetMyVouchers: false, getMyVouchersData: action.payload }
    case GET_MY_VOUCHERS_FAIL:
      return { loadingGetMyVouchers: false, errorGetMyVouchers: action.payload }
    case GET_MY_VOUCHERS_RESET:
      return {}
    default:
      return state
  }
}
